/**
 * 中秋皮肤状态（纯前端判断，与后端 utils/moon.js 活动窗口保持一致：
 * 2026-09-18 ~ 2026-10-12，活动结束自动失效）。
 * 全站皮肤（深蓝夜空 + 金边卡片 + 桂花橙按钮 + 导航 🌕🏮）由 App.vue 消费，
 * 满月跑马灯由首页消费。
 */

const MOON_START = '2026-09-18';
const MOON_END = '2026-10-12';

/** 东八区今日 YYYY-MM-DD */
function bjToday() {
  return new Date(Date.now() + 8 * 3600 * 1000).toISOString().slice(0, 10);
}

/** 中秋活动期间（全站皮肤开关） */
export function moonSkinActive() {
  const t = bjToday();
  return t >= MOON_START && t <= MOON_END;
}

/** 满月日：月相 15 天循环，第 10 天为满月（活动第 10 天与第 25 天） */
export function isFullMoonNight() {
  if (!moonSkinActive()) return false;
  const day =
    Math.round(
      (Date.parse(bjToday() + 'T00:00:00Z') - Date.parse(MOON_START + 'T00:00:00Z')) / 86400000
    ) + 1;
  return ((day - 1) % 15) + 1 === 10;
}